import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';

export interface FetchDescriptionVariables {
  origDescription: string;
  editOptions: string[];
  editInstruction?: string;
}

export type FetchDescriptionResult = { editDescription: { answer: string } };

const EDIT_DESCRIPTION_QUERY = gql`
  query ($origDescription: String!, $editInstruction: String, $editOptions: [String]!) {
    editDescription(
      origDescription: $origDescription
      editInstruction: $editInstruction
      editOptions: $editOptions
    ) {
      answer
    }
  }
`;

export const fetchDescription = async (
  variables: FetchDescriptionVariables & { signal?: AbortSignal }
): Promise<FetchDescriptionResult> => {
  const { signal, ...queryVariables } = variables;
  return gqlClient.request<FetchDescriptionResult>({
    document: EDIT_DESCRIPTION_QUERY,
    variables: queryVariables,
    signal
  });
};
